import { Controller } from "stimulus"

function getCsrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : ''
}

export default class extends Controller {
  static targets = ["container", "content"]
  static values = { tipId: String }

  connect() {
    // Record tip view when it's displayed
    if (this.hasTipIdValue && this.tipIdValue) {
      this.recordView()
    }
  }

  async recordView() {
    try {
      const response = await fetch(`/learning_tips/${this.tipIdValue}/view`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': getCsrfToken()
        }
      })

      if (response.ok) {
        const data = await response.json()

        // Update sidebar progress if visible
        this.updateSidebarProgress(data.progress)

        // Show achievement notifications
        if (data.newly_earned_achievements && data.newly_earned_achievements.length > 0) {
          data.newly_earned_achievements.forEach(achievement => {
            this.showAchievementNotification(achievement)
          })
        }
      }
    } catch (e) {
      console.error('Failed to record tip view:', e)
    }
  }

  updateSidebarProgress(progress) {
    const sidebarController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller="learning-sidebar"]'),
      'learning-sidebar'
    )
    if (sidebarController) {
      sidebarController.updateProgressDisplay(progress)
    }
  }

  showAchievementNotification(achievement) {
    const sidebarController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller="learning-sidebar"]'),
      'learning-sidebar'
    )
    if (sidebarController) {
      sidebarController.showAchievementNotification(achievement)
    } else {
      // Fallback notification
      this.createAchievementNotification(achievement)
    }
  }

  createAchievementNotification(achievement) {
    const notification = document.createElement('div')
    notification.className = 'achievement-notification'
    notification.innerHTML = `
      <div class="achievement-icon" style="color: ${achievement.badge_color}">
        <span class="${achievement.badge_icon}"></span>
      </div>
      <div class="achievement-content">
        <div class="achievement-title">Achievement Unlocked!</div>
        <div class="achievement-name">${achievement.name}</div>
        <div class="achievement-xp">+${achievement.xp_reward} XP</div>
      </div>
    `
    document.body.appendChild(notification)
    setTimeout(() => notification.remove(), 3500)
  }

  dismiss() {
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add('animate__fadeOut')
      setTimeout(() => this.containerTarget.remove(), 300)
    } else {
      this.element.classList.add('animate__fadeOut')
      setTimeout(() => this.element.remove(), 300)
    }
  }

  async showNext() {
    try {
      const response = await fetch('/learning_tips/next', {
        headers: { 'Accept': 'text/html' }
      })

      if (response.ok) {
        const html = await response.text()
        if (this.hasContentTarget) {
          this.contentTarget.innerHTML = html
        } else {
          // Replace entire element
          const temp = document.createElement('div')
          temp.innerHTML = html
          this.element.replaceWith(temp.firstElementChild)
        }
      }
    } catch (e) {
      console.error('Failed to load next tip:', e)
    }
  }
}
